(function($){
  $.fn.extend({
    thumbnailsGal: function (options) {
      var defaults = {
        mainImage: ".image-product",
        renderAfter: false,
        selector: ''
      };
      options = $.extend(defaults, options);
      return this.each(function () {
        // console.log($(this));
        let thumbnail = $(this).find("a"),
            mainImage = $(this).siblings().find(options.mainImage);
          if (options.renderAfter) {
              $(options.selector).on("click", 'a', function (e) {
                  e.preventDefault();
                  var galleryImage = $(this).attr("href");
                  mainImage.attr("src", galleryImage);
              });
          } else {
              thumbnail.on("click", function (e) {
                  e.preventDefault();
                  var galleryImage = $(this).attr("href");
                  mainImage.attr("src", galleryImage);
              });
          }
      });
    }
  });
})(jQuery);